export default __webpack_public_path__ + "static/media/01n.e8c25baf.svg";